export default __webpack_public_path__ + "static/media/allina-logo-icon.399e2663.png";